import { AlertTriangle } from 'lucide-react';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';

export function FilePreviewConfirm({
  title,
  description,
  confirmLabel,
  pending = false,
  danger = false,
  onConfirm,
  onClose,
}: {
  title: string;
  description?: string;
  confirmLabel: string;
  pending?: boolean;
  danger?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Dialog open onClose={onClose} className="relative z-[120]">
      <DialogBackdrop className="fixed inset-0 bg-ds-scrim" />
      <div className="fixed inset-0 z-[120] flex items-center justify-center p-s5">
        <DialogPanel className="w-full max-w-modal rounded-card bg-ds-card p-s5 shadow-[var(--sh-md)]">
          <div className="flex items-start gap-s4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-ds-coral-tint text-ds-coral-ink">
              <AlertTriangle className="h-5 w-5" aria-hidden />
            </span>
            <div className="min-w-0 flex-1">
              <DialogTitle className="text-[18px] font-semibold leading-6 text-ds-text">{title}</DialogTitle>
              {description ? <p className="mt-s2 text-[15px] leading-6 text-ds-text-2">{description}</p> : null}
            </div>
          </div>
          <div className="mt-s5 flex justify-end gap-s2">
            <Button type="button" variant="secondary" onClick={onClose} disabled={pending}>
              {t('common.cancel')}
            </Button>
            <Button
              type="button"
              variant={danger ? 'danger' : 'primary'}
              loading={pending}
              onClick={onConfirm}
            >
              {confirmLabel}
            </Button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
